import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import ShowDetails from '../../../Common/UploadDetails';
import { checkLineBreak } from '../../../utils/utils';
import { logFirebaseEvent } from '../firebase';
import {
  P2P_HELP_SUBMIT_FORM_BTN,
  P2P_HELP_SUBMIT_FORM_VIEW,
} from '../firebase/constant';
import { postTicketErrorReset, postTicketRequest } from './faqAction';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FaqForm from './FaqForm';

const FaqHelp = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const formikRef: any = useRef();
  const [selectedFile, setSelectedFile] = useState<any>(null);

  const [isFilePicked, setIsFilePicked] = useState(false);
  useEffect(() => {
    document.title = 'stashearn - faq-help';
    logFirebaseEvent(P2P_HELP_SUBMIT_FORM_VIEW);
  }, []);

  const initialValues = {
    message: '',
  };

  const validationSchema = () =>
    Yup.object().shape({
      message: Yup.string()
        .required('*Required')
        .test('lineBreak-check', 'invalid message', (value) =>
          checkLineBreak(value ? value : '')
        ),
    });

  const onSubmitHandle = (data: any) => {
    logFirebaseEvent(P2P_HELP_SUBMIT_FORM_BTN);
    let value;
    if (isFilePicked) {
      value = { ...data, selectedFile };
    } else {
      value = { ...data };
    }
    dispatch(postTicketRequest(value));
    // history.push('/p2p/faqCongratulations');
  };

  const { ticketResponse, ticketResponseError } = useSelector(
    (state: any) => state.ticket
  );
  const [responseError, setResponseError] = useState<any>(null);

  useEffect(() => {
    if (ticketResponse?.status) history.push('/p2p/faqCongratulations');
    dispatch(postTicketErrorReset());
    if (ticketResponseError?.status) setResponseError(ticketResponseError);
  }, [ticketResponse]);

  const onChangeField = () => {
    if (ticketResponseError?.error?.errors) {
      dispatch(postTicketErrorReset());
      setIsFilePicked(false);
    }
  };

  const handleUploadFile = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const enterKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      if (formikRef?.current?.isValid) {
        onSubmitHandle(formikRef.current.values);
      }
    }
  };

  return (
    <>
      <BackgroundTheme>
        <Card className='redBorder'>
          <CardContent>
            <FaqForm
              initialValues={initialValues}
              onSubmitHandle={onSubmitHandle}
              validationSchema={validationSchema}
              onChangeField={onChangeField}
              handleUploadFile={handleUploadFile}
              formikRef={formikRef}
              enterKeyPress={enterKeyPress}
            />
            {isFilePicked ? <ShowDetails selectedFile={selectedFile} /> : ''}
          </CardContent>
        </Card>
      </BackgroundTheme>
    </>
  );
};

export default FaqHelp;
